import { ButtonHTMLAttributes, DetailedHTMLProps } from 'react';

export enum ButtonThemes {
  Primary = 'primary',
  Secondary = 'secondary',
  Filter = 'filter',
  FilterTab = 'filterTab',
  Clear = 'clear',
  Success = 'success',
  Black = 'black',
  BlackSecondary = 'blackSecondary',
  Violet = 'violet',
  DarkViolet = 'darkViolet',
  FilterGray = 'filterGray',
}

export enum ButtonSize {
  S = 'small',
  M = 'medium',
  L = 'large',
  B = 'big',
}

export interface ButtonTypeProps extends DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
  className?: string;
  themes?: ButtonThemes;
  size?: ButtonSize;
  active?: boolean;
  fullWith?: boolean;
}
